const cancel = 'Ακύρωση'
const save = 'Αποθήκευση'

export default {

  global: {
    generalError: 'Λυπούμαστε, η επεξεργασία του αιτήματος δεν ήταν δυνατή. Παρακαλούμε φορτώστε ξανά τη σελίδα.',
    signature: 'Με εκτίμηση,',
  },

  component: {
    actionBar: {
      actions: 'Actions',
      hideActions: 'Hide actions',
      next: 'Next',
      previous: 'Previous',
    },

    addButton: {
      add: 'Add',
    },

    aiSummaryBox: {
      transcript: 'Transcript',
      summary: 'Summary',
    },

    attachments: {
      add: 'Προσθήκη βιογραφικού ή άλλων εγγράφων',
      placeholderWithDescription: 'Προσθέστε τα απαιτούμενα συνημμένα',
      remove: 'Κατάργηση',
      allowedFileTypes: 'Επιτρεπόμενοι τύποι αρχείων',
      errors: {
        size: 'Το αρχείο είναι πολύ μεγάλο. Το μέγιστο μέγεθος αρχείων είναι 5MB.',
        empty: 'Κενό αρχείο',
        invalidType: fileType => `Λυπούμαστε, αλλά τα αρχεία ${fileType} δεν γίνονται αποδεκτά για λόγους ασφαλείας`,
        typeNotWhitelisted: 'Λυπούμαστε, αυτός ο τύπος αρχείου δεν επιτρέπεται.',
      },
    },

    agreeTos: {
      privacyLinkText: 'Πολιτική απορρήτου',
      termsLinkText: 'Όρους και προϋποθέσεις',
      privacyPolicyText: 'Εκτιμούμε το προσωπικό σας απόρρητο. Διαβάστε την ',
      termsText1: 'Διαβάστε και αποδεχτείτε τους ',
      termsText2: 'πριν μας παράσχετε τα προσωπικά σας δεδομένα.',
      privacyLink: 'https://get.recright.com/privacy-policy',
      termsLink: 'https://get.recright.com/recright-terms-and-conditions-candidate',
      privacyInfo: mail => `Εάν δεν θέλετε να επεξεργαστούμε τα προσωπικά δεδομένα σας, μπορείτε να ζητήσετε διαγραφή αποστέλλοντας μήνυμα στη διεύθυνση ${mail}.`,
      customSupportPrivacyInfo: link => `Εάν δεν θέλετε να επεξεργαστούμε τα προσωπικά δεδομένα σας, μπορείτε να ζητήσετε την αφαίρεσή τους, επικοινωνώντας στη διεύθυνση ${link}.`,
    },

    buttons: {
      close: 'Κλείσιμο',
    },

    competencies: {
      addCompetency: 'Add a new competency',
      edit: 'Edit competencies',
      done: 'Done',
      defaultsDescription: 'If you are unsure what competencies to use, we have defined some good defaults to start with.',
      getDefaults: 'Get default competencies',
    },

    competency: {
      warning: 'Remove competency and all its ratings?',
    },

    confirmDelete: {
      delete: 'Delete',
      cancel: 'Cancel',
      confirm: 'Confirm',
    },

    confirm: {
      cancel: 'Κατάργηση λήψης',
      confirm: 'Δοκιμάστε ξανά',
    },

    confirmButton: {
      wait: count => `Περιμένετε ${count}`,
      confirm: 'Επιβεβαίωση',
    },

    controlStatus: {
      text: {
        empty: 'Συμπληρώστε',
        valid: () => 'Ολοκληρώθηκε',
      },
      textarea: {
        empty: 'Συμπληρώστε',
        valid: (length, limit) => `${length}/${limit}`,
      },
      select: {
        empty: 'Καθορισμός',
        valid: () => 'Ολοκληρώθηκε',
      },
      file: {
        empty: 'Επιλογή',
        valid: () => 'Αλλαγή',
      },
      list: {
        empty: 'Προσθήκη',
        valid: (length, limit) => `${length}/${limit}`,
      },
      search: {
        empty: 'Αναζήτηση',
        valid: () => 'Ολοκληρώθηκε',
      },
    },

    cookieConsentModal: {
      title: 'Ο ιστότοπός μας χρησιμοποιεί cookies',
      body: 'Με την αποδοχή όλων των cookies, συμφωνείτε με την αποθήκευση των cookies στη συσκευή σας για τη βελτίωση της πλοήγησης στον ιστότοπο, την ανάλυση της χρήσης του ιστοτόπου και την υποστήριξη των δραστηριοτήτων μας στο πεδίο του μάρκετινγκ.',
      learnMoreLinkText:
        'Μάθετε περισσότερα για τη χρήση των cookies στον ιστότοπό μας',
      learnMoreLink: 'https://get.recright.com/cookies/', // TODO add localized links when the page is translated
      manageCookies: 'Διαχείριση των cookies',
      acceptAll: 'Αποδοχή όλων των cookies',
      manageTitle: 'Διαχείριση προτιμήσεων συναίνεσης',
      necessaryCookiesTitle: 'Απαραίτητα cookies',
      necessaryCookiesBody:
        'Αυτά τα cookies είναι απαραίτητα για τη λειτουργία του ιστοτόπου και δεν μπορούν να απενεργοποιηθούν στα συστήματά μας.',
      performanceCookiesTitle: 'Cookies απόδοσης',
      performanceCookiesBody:
        'Αυτά τα cookies μάς επιτρέπουν να μετράμε τις επισκέψεις και τις πηγές επισκεψιμότητας, ώστε να μπορούμε να μετράμε και να βελτιώνουμε την απόδοση του ιστοτόπου μας.',
      confirmChoices: 'Επιβεβαίωση των επιλογών μου',
      marketingCookiesTitle: 'Cookies για σκοπούς μάρκετινγκ',
      marketingCookiesBody:
        'Αυτά τα cookies μάς επιτρέπουν να εξατομικεύουμε τις διαφημίσεις και να μετράμε την απόδοσή τους.',
      functionalCookiesTitle: 'Λειτουργικά cookies',
      functionalCookiesBody:
        'Αυτά τα cookies χρησιμοποιούνται για τη βελτίωση της λειτουργικότητας του ιστοτόπου. Χωρίς αυτά τα cookies, ορισμένες λειτουργίες ενδέχεται να μην είναι διαθέσιμες. Παραδείγματα λειτουργικών cookies περιλαμβάνουν υπηρεσίες διαδικτυακής συνομιλίας και προτιμήσεις χρηστών.',
    },

    emailAddresses: {
      candidateNamePlaceholder: 'Candidate name',
      remove: 'Κατάργηση',
      importCsv: 'Import CSV',
      invalidEmails: 'Invalid emails found.',
      maxCsvEntryErrorNotification: amount =>
        `Max ${amount} csv entries allowed`,
      importCsvTooltip:
        'The csv rows can have email or email,phone. Each row represents a recipient. The phone numbers needs to be in international format (E.164) e.g. (<strong>+358</strong>50xxxxxxx).',
    },

    emailDeliveryStatus: {
      Undetermined: {
        Undetermined: 'Email bounced back. Make sure the recipient received your message.',
      },
      Permanent: {
        General: 'Email delivery failed. Recipients email provider rejected the message.',
        NoEmail: 'Email address does not exist.',
        Suppressed: 'Email was not delivered due to previous unsuccessful delivery attempts.',
      },
      Transient: {
        General: 'Email bounced back. Make sure the recipient received your message.',
        MailboxFull: 'Recipient inbox is full.',
        MessageTooLarge: 'The message content is too large.',
        ContentRejected: 'The message content rejected.',
        AttachmentRejected: 'The attachment rejected.',
      },
    },

    smsDeliveryStatus: {
      notDelivered: 'SMS message added to message queue, waiting for delivery.',
      failed: 'Sending SMS message failed.',
      duplicate: 'The number given is already attatched to a candidate in the interview.',
    },

    error403: {
      heading: 'Απαγορεύεται',
      content: 'Ο διακομιστής μας αρνήθηκε ευγενικά (αλλά κατηγορηματικά) να εκτελέσει ένα αίτημα του περιηγητή σας. Επισημαίνεται ότι η υπηρεσία Recright πρέπει να χρησιμοποιείται σε μία συσκευή/έναν περιηγητή (ταυτόχρονα).',
      link: 'Πρώτη σελίδα',
    },

    error404: {
      heading: 'Δεν βρέθηκε',
      content: 'Λυπούμαστε, αλλά δεν βρέθηκε σελίδα στη διεύθυνση που ζητήσατε. Ίσως ο σύνδεσμος που ακολουθήσατε έληξε ή κατά λάθος πληκτρολογήσατε λανθασμένη διεύθυνση.',
      link: 'Πρώτη σελίδα',
    },

    error410: {
      heading: 'Έκλεισε',
      content: 'Η εμφάνιση της θέσης εργασίας δεν είναι δυνατή, επειδή είτε έκλεισε είτε έληξε η περίοδος υποβολής αίτησης.',
      link: 'Πρώτη σελίδα',
    },

    calendarError: {
      heading: 'Connecting calendar failed',
      content: 'We were unable to connect your calendar. Please try again later and if the issue continues please contact our support.',
    },

    flash: {
      starting: 'Εκκίνηση...',
      connection_error_hint: 'Δεν βρέθηκε σύνδεση δικτύου.\nΔοκιμάστε να ξαναφορτώσετε τη σελίδα.',
      permission_hint: 'Πρέπει να επιτρέψετε σε αυτή τη σελίδα να χρησιμοποιεί την κάμερα διαδικτύου και το μικρόφωνό σας.',
      searching_camera_hint: 'Αναζήτηση κάμερας διαδικτύου...',
      camera_reserved_hint: 'Η κάμερα διαδικτύου σας χρησιμοποιείται από άλλη εφαρμογή ή ιστοσελίδα.\nΠαρακαλούμε κλείστε αυτήν την εφαρμογή και ξαναφορτώστε τη σελίδα.',
      camera_reserved_hint_chrome_extra: 'Αγαπητέ χρήστη του Chrome, πρέπει να επιτρέψετε στην υπηρεσία Recright να χρησιμοποιήσει την κάμερα διαδικτύου από το παράθυρο διαλόγου κάτω από τη μπάρα διευθύνσεων.',
      no_camera_hint: 'Δεν βρέθηκε κάμερα διαδικτύου.',
      no_mic_hint: 'Δεν βρέθηκε μικρόφωνο.',
      uploading_text: 'Αναφόρτωση...',
      rtmpt_in_use: 'Αυτό το βήμα δεν θα ήταν απαραίτητο, εάν ο διαχειριστής\nδικτύου σας επέτρεπε το πρωτόκολλο RTMP. Ρωτήστε μας πώς μπορεί να γίνει αυτό.',
      preview_text: 'Η κάμερα διαδικτύου είναι σε λειτουργία προεπισκόπησης',
      close_text: 'Κλείσιμο κάμερας',
      remove_text: 'Κατάργηση λήψης',
      noflash_errortext_install: link => `Μάλλον δεν διαθέτετε το Adobe Flash Player. Χρειάζεστε ένα πρόσθετο flash για τη μαγνητοσκόπηση βίντεο. Πραγματοποιήστε λήψη του flash από εδώ: ${link}`,
      noflash_errortext_enable: link => `Εάν έχετε ήδη εγκαταστήσει το flash, αλλά εξακολουθείτε να βλέπετε αυτό το μήνυμα. Δείτε εδώ: ${link}`,
      noflash_errortext_differentbrowser: 'Διαφορετικά, μπορείτε να δοκιμάσετε με έναν περιηγητή που υποστηρίζει εγγραφή βίντεο σε μορφή HTML5. Προτείνουμε τον Chrome ή τον Firefox.',
    },

    footer: {
      terms: 'Όροι',
      license: 'General Terms of Service',
      privacyPolicy: 'Πολιτική απορρήτου',
      customSupport: link => `Επικοινωνήστε στο ${link}`,
      accessibilityReport: 'Accessibility report',
    },

    feedbackPulse: {
      howWouldYouRateInterview: 'Πώς σας φάνηκε η συνέντευξη;',
      howWouldYouRateJobAd: 'Πώς θα αξιολογούσατε την εμπειρία σας ως προς τη χρήση της εφαρμογής;',
      yourResponseIsAnonymous: 'Η απάντησή σας είναι ανώνυμη.',
      thankYouFeedback: 'Σας ευχαριστούμε για τα σχόλιά σας!',
    },

    candidateFooter: {
      termsLink: 'https://get.recright.com/recright-terms-and-conditions-candidate',
      privacyPolicyLink: 'https://get.recright.com/privacy-policy',
      accessibilityReportLink: 'https://websitemedia.recright.com/wp-content/uploads/2024/11/06112306/accessibility_report.pdf',
    },

    formErrors: {
      typeNotWhitelisted: 'Λυπούμαστε, αυτός ο τύπος αρχείου δεν επιτρέπεται.',
      isRequired: 'Αυτό το πεδίο είναι υποχρεωτικό.',
      isEmail: value => `Η διεύθυνση email ${value} δεν είναι έγκυρη.`,
      isDate: value => `Η ημερομηνία ${value} δεν είναι έγκυρη.`,
      invalidUrl: 'Μη έγκυρη διεύθυνση URL.',
      singleHireEndError: 'Η περιστασιακή πρόσληψη δεν είναι δυνατή για διάστημα μεγαλύτερο των 60 ημερών.',
      isNotTooOldForLive: 'Η ημερομηνία έχει περάσει.',
      isNotAfterEndDate: 'The date is after the date the job ad closes.',
      isValidMobilePhone: value => `${value ? `${value} is not` : 'Not'} a valid mobile phone number.`,
      isInternationalPhoneNumber: 'Phone number must be in international format.',
      duplicateNumber: 'Phone number has already been added',
      duplicateCompetency: 'Competency with that name already exists',
      isNotDuplicateTemplateName: 'Template with that name already exists',
    },

    jobAdApplication: {
      name: 'Όνομα',
      city: 'Τόπος κατοικίας',
      email: 'Email',
      phone: 'Τηλέφωνο',
      applyForPosition: 'Υποβολή αίτησης για τη θέση',
      back: 'Πίσω',
      continue: 'Συνέχεια',
      submit: 'Υποβολή',
      saveForLater: 'Συνέχεια αργότερα',
      namePlaceholder: 'Εισαγωγή ονόματος',
      emailPlaceholder: 'Εισαγωγή διεύθυνσης email',
      phonePlaceholder: 'Εισαγωγή αριθμού τηλεφώνου',
      cityPlaceholder: 'Εισαγωγή τρέχουσας πόλης κατοικίας',
      links: 'Προσθήκη συνδέσμων, π.χ. του προφίλ σας στο LinkedIn',
      legendBasicInfo: 'Βασικές πληροφορίες',
      legendLinks: 'Σύνδεσμοι',
      legendAttachments: 'Επισυνάψεις',
      legendAdditionalFields: 'Πρόσθετες πληροφορίες',
      coverLetter: 'Συνοδευτική επιστολή',
      attachments: 'Επισυνάψεις',
      introduction: 'Γράψτε μια σύντομη παρουσίαση του εαυτού σας εδώ',
      thankYou: 'Σας ευχαριστούμε.',
      luck: 'Καλή τύχη!',
      close: 'Κλείσιμο',
      required: 'Τα πεδία που επισημαίνονται με *αστερίσκο είναι υποχρεωτικά.',
    },

    jobAdContainer: {
      endTime: date => (date ? `ανοικτή έως ${date}` : ''),
    },

    jobAdDetails: {
      apply: 'Υποβολή αίτησης για τη θέση εργασίας',
    },

    jobAdQuickInterview: {
      back: 'Πίσω',
      submit: 'Υποβολή',
      saveForLater: 'Συνέχεια αργότερα',
      title: 'Γρήγορη συνέντευξη μέσω βίντεο',
      description: 'Για να σας γνωρίσουμε γρηγορότερα, θα θέλαμε να απαντήσετε εν συντομία στην ερώτησή μας στο πλαίσιο γρήγορης συνέντευξης. Δώστε το προσωπικό σας στίγμα και ζωντανέψτε την αίτησή σας.',
      requiredNote: 'Επισημαίνεται ότι το παρόν αποτελεί ένα μέρος της διαδικασίας αίτησης, και η εταιρεία πρόσληψης θα λάβει την αίτησή σας μόλις μαγνητοσκοπήσετε την απάντησή σας.',
      reminderNote: 'Μπορείτε να μαγνητοσκοπήσετε την απάντηση αμέσως, ή μπορείτε να συνεχίσετε αργότερα, αφού λάβετε μήνυμα υπενθύμισης στο email σας.',
    },

    jobAdRow: {
      responses: 'Αιτήσεις',
      status: {
        open: 'Ανοικτή',
        filled: 'Συμπληρώθηκε',
        cancelled: 'Ακυρώθηκε',
        done: 'Τέλος',
        close: 'Κλείσιμο',
        draft: 'Έκλεισε (πρόχειρο)',
        hidden: 'Κρυφό',
      },
    },

    interviewRow: {
      responses: 'Υποψήφιοι',
    },

    linkedInProfile: {
      showLinkedInProfileModal: 'Προβολή προφίλ στο LinkedIn',
    },

    linkedInButton: {
      error: 'Παρουσιάστηκε σφάλμα κατά την εύρεση του προφίλ. Παρακαλούμε, δοκιμάστε ξανά.',
      buttonText: 'Υποβάλετε αίτηση μέσω LinkedIn',
    },

    linkedInContainer: {
      linkedInButtonDescription: 'Μπορείτε να χρησιμοποιήσετε το προφίλ σας στο LinkedIn για να προσυμπληρώσετε το έντυπο της αίτησης',
      linkedInOr: 'Ή',
      error: 'Παρουσιάστηκε σφάλμα κατά την εύρεση του προφίλ. Παρακαλούμε, δοκιμάστε ξανά.',
    },

    linkListInput: {
      addField: 'Προσθήκη',
      removeField: 'Κατάργηση',
      invalidUrl: 'Μη έγκυρη διεύθυνση URL.',
    },

    liveRoom: {
      greeting: name => `Hello, ${name}.`,
      notYetStarted: startTime =>
        `The interview has not yet started. The interview starts at ${startTime}.`,
      interviewTitle: title => `Interview title: ${title}`,
      interviewStartsIn: timeLeft => `The Interview starts in: ${timeLeft}`,
      interviewHasEnded: 'The interview has ended.',
      youHaveLeft: 'You have left the interview.',
      rejoinInterview: 'Rejoin interview',
      joinInterview: 'Join interview',
      goToEvaluations: 'Continue to evaluation',
      structuredInterview: {
        timeEstimateText: timeEstimate => `${timeEstimate} minutes`,
        guideNotesPlaceHolder: stepTitle => `Notes for ${stepTitle}`,
        goToNextStepButtonText: 'Go to next section',
        totalTime: 'Total time in interview:',
        timeIn: partName => `Time in ${partName}:`,
        nextStep: stepTitle => `Next up: ${stepTitle}`,
      },
    },

    loadingButton: {
      loading: 'Φόρτωση...',
      saving: 'Αποθήκευση...',
      sending: 'Αποστολή...',
    },

    modalApplicationForm: {
      applyForPosition: 'Υποβολή αίτησης για τη θέση',
      continue: 'Συνέχεια',
      name: 'Εισαγωγή ονόματος',
      email: 'Εισαγωγή διεύθυνσης email',
      phoneNumber: 'Εισαγωγή αριθμού τηλεφώνου',
      links: 'Μπορείτε να εισαγάγετε συνδέσμους',
      legendLinks: 'Σύνδεσμοι',
      legendAttachments: 'Επισυνάψεις',
      coverLetter: 'Συνοδευτική επιστολή',
      attachments: 'Επισυνάψεις',
      introduction: 'Γράψτε εδώ τον πρόλογό σας.',
      thankYou: 'Σας ευχαριστούμε.',
      luck: 'Καλή τύχη!',
      close: 'Κλείσιμο',
    },

    modalConfirm: {
      cancel,
      confirm: 'OK',
    },

    modalAlert: {
      close: 'Close',
    },

    modalLinkShare: {
      title: 'Κοινόχρηστος δημόσιος σύνδεσμος',
      info: 'Αυτή η δημόσια διεύθυνση αγγελίας εργασίας μπορεί να κοινοποιηθεί.\nΌποιος ενδιαφέρεται για τη θέση μπορεί να δει την αγγελία εργασίας και στη συνέχεια να αποφασίσει, αν θα υποβάλει αίτηση.\nθα λάβετε τη συνήθη ειδοποίηση, όταν αρχίσουν να υποβάλλονται αιτήσεις.',
    },

    modalVideoAdd: {
      title: 'Προσθήκη νέου βίντεο',
      chooseTitle: 'Προσθήκη νέου βίντεο',
      titlePlaceholder: 'Εισαγωγή τίτλου βίντεο εδώ',
      cancel,
      save,
    },

    modalVideoUpload: {
      title: 'Αναφόρτωση νέου βίντεο',
      info: 'Το μέγιστο επιτρεπόμενο μέγεθος βίντεο είναι 500mb. Συνιστούμε τα βίντεο να συμπιέζονται πριν την αναφόρτωσή τους. Με αυτόν τον τρόπο, η αναφόρτωση και μετατροπή θα διαρκούν λιγότερο.',
    },

    modalCandidateInfo: [
      {
        headline: 'Μαγνητοσκοπήστε την απάντησή σας ',
        content: 'όσες φορές θέλετε. Τα βίντεο θα αποθηκεύονται αμέσως μετά την εγγραφή τους και μπορείτε να επιστρέψετε στη συνέντευξη μέσω βίντεο, ακολουθώντας τον σύνδεσμο που λάβατε στο email σας.',
        mobileContent: 'όσες φορές θέλετε. Προσθέστε το βίντεο στη συνέντευξη. Θα δείτε ότι το βίντεο αναφορτώνεται και αποθηκεύεται στη συνέντευξη. Μπορείτε να επιστρέψετε στη συνέντευξη μέσω βίντεο, ακολουθώντας τον σύνδεσμο που λάβατε στο email σας. <br><br><strong>Εάν η οθόνη βίντεο παραμένει μαύρη και χρησιμοποιείτε φορητή συσκευή της Apple, θα βρείτε οδηγίες για την επίλυση του προβλήματος <a style="text-decoration: underline;" target="_blank" rel="noopener noreferrer" href="https://support.recright.com/en/articles/11187-recording-doesn-t-work-with-ipad-iphone">εδώ</a>.</strong>',
      },
      {
        headline: 'Μετά την εγγραφή του βίντεο, ',
        content: 'βεβαιωθείτε ότι το βίντεο παίζει σωστά και η φωνή σας ακούγεται. Όταν πατήσετε το κουμπί «Αποστολή», η απάντησή σας θα οριστικοποιηθεί και δεν θα μπορείτε πλέον να την επεξεργαστείτε.',
      },
      {
        headline: 'Όταν ολοκληρώσετε τη συνέντευξη, ',
        content: 'πατήστε το κουμπί «Αποστολή απαντήσεων και ολοκλήρωση συνέντευξης». Μετά από αυτήν την ενέργεια δεν μπορείτε να επιστρέψετε στη συνέντευξη μέσω βίντεο. Εάν θέλετε να κλείσετε αυτή τη σελίδα, αλλά να συνεχίσετε τη συνέντευξη αργότερα, πατήστε το κουμπί «Συνέχεια αργότερα».',
      },
      {
        headline: 'Εάν χρειάζεστε βοήθεια ',
        content: mailto => `με την υποβολή απαντήσεων στη συνέντευξη μέσω βίντεο, πατήστε το κουμπί «βοήθεια» στην κάτω δεξιά πλευρά της σελίδας ή στείλτε μας ένα email στη διεύθυνση ${mailto}.`,
        customContent: link => `Επικοινωνήστε στο ${link}`,
      },
    ],

    navigationBar: {
      back: 'Πίσω',
      dashboard: 'Πίνακας ελέγχου',
      frontpage: 'Πρώτη σελίδα',
    },

    personDetails: {
      stage: 'Stage',
      namePlaceholder: 'Candidate',
      contact: 'Contact',
      links: 'Links',
      attachments: 'Attachments',
      coverLetter: 'Cover Letter',
      referrer: 'Origin',
      referrerInfo: 'The website from which the candidate came to the service.',
      noStage: 'Not in any stage yet',
      lastSeen: time => `Last seen ${time}.`,
      headerAdditionalInformation: 'Additional information',
      state: {
        invited: 'Invited',
        visited: 'Visited',
        incomplete: 'Incomplete',
        completed: 'Completed',
      },
      notVisited: 'Hasn\'t yet visited the interview.',
      scheduledInterview: 'Scheduled interview',
      scheduledInterviewInvitationSent: 'Invited to a meeting',
      scheduledInterviewInvitationExpired: 'Invitation has expired',
      scheduledInterviewInvitationEventCreated: 'Meeting:',
      scheduledInterviewReScheduleMeeting: 'Reschedule meeting',
      otherPersons: count => `Also found on ${count} other positions`,
    },

    phoneInput: {
      placeholder: example => `Τηλέφωνο σε μορφή ${example}`,
    },

    questionsAndResponses: {
      response: 'Response',
      noResponse: 'No response',
      resetQuestionResponse: 'Delete candidate response',
      resetQuestionResponseConfirm: questionTitle =>
        `Are you sure you want to reset the question "${questionTitle}" for the candidate and delete their response?`,
      resetQuestionResponseConfirm2: 'If you do this, candidate can retake this question.',
      aiInsights: 'AI Insights',
      showQuestion: 'Show question video',
      hideQuestion: 'Hide question video',
      question: 'Question',
      nonAnswerableInfo: 'Question is non-answerable.',
      evaluationCriteriaLabel: 'Evaluation criteria',
    },

    rating: {
      ownVote: 'Your rating',
      yourVotePlaceholder: 'You have not voted yet.',
      totalVotes: count => `Total ${count} ratings`,
      noRatings: 'No ratings yet',
      mobileModalHeader: 'Add your rating',
      yourRatingReset: 'Reset your vote',
      averageRating: 'Μέση βαθμολογία',
      reset: 'επαναφορά',
    },

    share: {
      share: 'Κοινοποίηση προς',
      copy: 'Αντιγραφή συνδέσμου',
    },

    sort: {
      sort: 'Ταξινόμηση',
    },

    supportLink: 'support@recright.com',

    typeSelect: {
      selected: 'Επιλογή',
      change: 'Αλλαγή',
    },

    video: {
      videoNotFound: 'Το βίντεο είναι υπό επεξεργασία ή δεν βρέθηκε',
      retry: 'Δοκιμάστε ξανά',
      originalLanguageLabel: 'Πρωτότυπο',
      englishLanguageLabel: 'Αγγλικά',
    },

    videoUpload: {
      uploadPlaceholder: isMobile => (isMobile ? 'Αναφόρτωση ή εγγραφή νέου βίντεο' : 'Επιλογή αρχείου'),
      videoPlaceholder: 'Μαγνητοσκόπηση απάντησης',
      uploadPlaceholderCandidate: 'Αναφόρτωση βίντεο',
      submit: 'Υποβολή απάντησης',
      notAnswered: 'Δεν έχετε απαντήσει ακόμη',
      remove: 'Κατάργηση λήψης',
      converting: 'Μετατροπή βίντεο σε εξέλιξη. Παρακαλούμε περιμένετε...',
      uploading: 'Αναφόρτωση βίντεο σε εξέλιξη. Παρακαλούμε περιμένετε...',
      error: {
        invalid: 'Το επιλεγμένο αρχείο είναι πολύ μεγάλο. Παρακαλούμε επιλέξτε άλλο αρχείο.',
        upload: 'Λυπούμαστε, η αναφόρτωση του βίντεο δεν ήταν δυνατή. Δοκιμάστε ξανά.',
        transcode: 'Το επιλεγμένο αρχείο βίντεο ήταν κατεστραμμένο ή μη έγκυρο, δοκιμάστε ξανά.',
      },
    },

    virtualBg: {
      showMoreButtonText: 'Εμφάνιση περισσότερων',
      showLessButtonText: 'Εμφάνιση λιγότερων',
      infoText1:
        'Κρατήστε την καρτέλα ενεργή στο προσκήνιο κατά την εγγραφή. Μη χρησιμοποιήσετε καμία άλλη εφαρμογή κατά την εγγραφή.',
      infoText2:
        'Τα βίντεο φόντου λειτουργούν καλύτερα στα νεότερα προγράμματα περιήγησης και με συσκευή σχετικά νέα και ισχυρή.',
      infoText3:
        'Βεβαιωθείτε ότι άλλες εφαρμογές δεν χρησιμοποιούν το μικρόφωνο ή την κάμερα.',
    },

    webcam: {
      useVideoBgButtonText: 'Χρήση βίντεο ως φόντου',
      removeVideoBgButtonText: 'Αφαίρεση βίντεο φόντου',
      starting: 'Έναρξη...',
      close: 'Κλείσιμο κάμερας',
      remove: 'Κατάργηση λήψης',
      record: 'Εγγραφή',
      stop: 'Διακοπή',
      retake: 'Επανάληψη',
      submit: 'Υποβολή απάντησης',
      converting: 'Μετατροπή βίντεο σε εξέλιξη. Παρακαλούμε περιμένετε...',
      uploading: 'Αναφόρτωση βίντεο σε εξέλιξη. Παρακαλούμε περιμένετε...',
      downloading: 'Καταφόρτωση βίντεο σε εξέλιξη. Παρακαλούμε περιμένετε...',
      processing: 'Επεξεργασία...',
      uploadInProgress: 'Η μεταφορά του βίντεο βρίσκεται σε εξέλιξη, μην κλείσετε τον περιηγητή ή αλλάξετε σελίδα.',
      uploaded: 'Η μεταφορά βίντεο ολοκληρώθηκε.',
      error: {
        DevicesNotFoundError: 'Η χρήση της κάμερας ή του μικροφώνου δεν είναι δυνατή. Παρακαλούμε ελέγξτε, εάν έχουν ενεργοποιηθεί.',
        NotFoundError: 'Η χρήση της κάμερας ή του μικροφώνου δεν είναι δυνατή. Παρακαλούμε ελέγξτε, εάν έχουν ενεργοποιηθεί.',
        NotAllowedError: 'Δεν δώσατε άδεια χρήσης της κάμερας ή του μικροφώνου.',
        PermissionDismissedError: 'Παραβλέψατε το παράθυρο διαλόγου σχετικά με την άδεια χρήσης. Παρακαλούμε δώστε άδεια για τη χρήση της κάμερας και του μικροφώνου.',
        PermissionDeniedError: 'Δεν εγκρίνατε την πρόσβαση στην κάμερα ή στο μικρόφωνο.',
        NotReadableError: 'Η ανάγνωση της ροής της κάμερας ή του μικροφώνου δεν είναι δυνατή. Πιθανό πρόβλημα υλικού.',
        SecurityError: 'Αδυναμία χρήσης κάμερας ή μικροφώνου λόγω σφάλματος ασφαλείας.',
        stream: 'Παρουσιάστηκε σφάλμα. Παρακαλούμε κάντε επανεκκίνηση του περιηγήτή σας. Εάν το πρόβλημα παραμένει, δοκιμάστε με διαφορετικό περιηγητή.',
        download: 'Αποτυχία καταφόρτωσης βίντεο. Δοκιμάστε ξανά.',
        upload: 'Αποτυχία αναφόρτωσης βίντεο. Δοκιμάστε ξανά.',
        emptyBlob: 'Η μνήμη του περιηγητή ή της συσκευής σας είναι πλήρης και δεν μπορεί να ολοκληρώσει την εγγραφή του βίντεο. Παρακαλούμε ανανεώστε τη σελίδα και αν αυτό δεν βοηθήσει, επανεκκινήστε τον περιηγητή σας. Εάν το πρόβλημα παραμένει, παρακαλούμε δοκιμάστε με διαφορετικό περιηγητή.',
        alternativeRecorder: 'Μπορείτε επίσης να ανεβάσετε αρχεία κάνοντας κλικ εδώ.',
        reconnecting: 'Η σύνδεση διακόπηκε. Δοκιμάστε να συνδεθείτε ξανά.',
      },
    },

    videoResponse: {
      videoPlaceholder: 'Μαγνητοσκόπηση απάντησης',
      uploadPlaceholder: 'Αναφόρτωση βίντεο',
      submit: 'Υποβολή απάντησης',
      notAnswered: 'Δεν έχετε απαντήσει ακόμη',
      required: 'Αυτή η ερώτηση απαιτεί απάντηση',
      startInterview: 'Έναρξη συνέντευξης',
    },

    smsMessages: {
      invitationMessage: title =>
        `Γεια! Θέλουμε να σας προσκαλέσουμε σε συνέντευξη ${title} μέσω βίντεο! Αυτή η πρόσκληση έχει σταλεί και στο email σας.`,
    },
  },
  page: {
    interviewPreview: {
      info: 'This is a preview of the interview. Video recording is disabled and the form data is not saved.',
    },
  },
}
